import { Component, Input } from '@angular/core';
import { Approval } from 'app/models/dto/approval/approval.model';
import { OfferOption } from 'app/models/dto/offer-option/offer-option.model';
import { Deal } from 'app/models/dto/deal.model';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-approvals-and-offers',
  templateUrl: './approvals-and-offers.component.html',
  standalone: false
})
export class ApprovalsAndOffersComponent {
    @Input() approvalsLoading: boolean = false;
    @Input() approvals: Approval[] = [];
    @Input() offerOptions: OfferOption[] = [];
    @Input() deal: Deal;
    @Input() readOnly: boolean = false;
    @Input() canRecommendOptions: boolean = false;
    @Input() canSeeFunctionalApprovals: boolean = false;
    @Input() hasContractRequest: boolean = false;
    @Input() advancedDeal: boolean = false;
    constructor(private store: Store){}
}